import { render, staticRenderFns } from "./VEstimatesPagesWrapper.vue?vue&type=template&id=b8def6d0&"
import script from "./VEstimatesPagesWrapper.vue?vue&type=script&lang=ts&"
export * from "./VEstimatesPagesWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./VEstimatesPagesWrapper.vue?vue&type=style&index=0&id=b8def6d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports